import { useState, useEffect    }   from 'react'
import { useJustificationPage   }   from '../../contexts/JustificationPageContext.js'
import { usePushNotifications   }   from '../../contexts/PushNotificationsContext'
import JustificationFileForm        from './JustificationFileForm.js'
import api                          from '../../services/api.js'
import { useUser                }   from '../../contexts/UserContext.js'

function JustificationFileFormContainer() {

    const { 

        handerCloseJustificationFileForm, 
        handleUpadeComparisionTable,
        isJustificationFileFormOpen, 
        comparisionTypes,
        handlerUpdateFilter

    } = useJustificationPage()

	const { setContentPushNotification } = usePushNotifications()
    const { userData }                   = useUser()
    
    const [files,                  	    setFiles                 ] = useState([])
    const [selectedPlanningRange,  	    setSelectedPlanningRange ] = useState(null)
	const [__errorMessage,        	    __setErrorMessage        ] = useState(null)
    const [__isloading,                 __setLoading             ] = useState(false)
    const [_comparisionTypesInputData,  _setComparisionTypesInputData    ] = useState([])


    const handleChangePlanningRange = (selectedOption) => {
        setSelectedPlanningRange(selectedOption) 
    }

    const __closeForm = () => {
        
        handlerUpdateFilter()
        setFiles([])
        
        __setLoading(false)
        __setErrorMessage(null)
        
        handerCloseJustificationFileForm()
    }

    const handleSubmit = async (data) => {
    
        __setLoading(true)
		
        try{
			
			const formData = new FormData()

			formData.append('excelFile',            data.excelFile              )
            formData.append('selectedDemandTypeId', selectedPlanningRange.value )
            formData.append('userId',               userData.id                 )

			await api.post('/createComparisionPost', formData, {
				headers: {
				    'Content-Type': 'multipart/form-data'
				}
			})
			
			setContentPushNotification({title: 'Sucesso', message: 'Comparações postadas com sucesso.'})
            __closeForm()
            handleUpadeComparisionTable()

        } catch (error) {
        
            __setLoading(false)
            __setErrorMessage(error.response.data.message || 'Ocorreu um erro ao processar o arquivo. Por favor, tente novamente.')
        
        }
        
    }


    function setupComparisionTypesInput() {
            
        try {

            const justificationTypes = comparisionTypes.map(t => ({ 
                label: t.name, 
                value: t.id 
            }))
          
            if (justificationTypes.length > 0) {
                setSelectedPlanningRange(justificationTypes[0])
                _setComparisionTypesInputData(justificationTypes)
            }

        } catch (error) {
            console.log('error fetching comparision types:', error)
        }
        
    }

    useEffect(() => {

        setupComparisionTypesInput()
    
	}, [comparisionTypes])

    return(
    
        <JustificationFileForm 
            
            isOpen={isJustificationFileFormOpen}
            onClose={__closeForm}
            onSubmit={handleSubmit}
            isloading={__isloading}
 
            setFiles={setFiles} 
            files={files}
            
            selectValues={_comparisionTypesInputData}
            handleChangePlanningRange={handleChangePlanningRange}
            
			errorMessage={__errorMessage}
            
        />

    )
}


export default JustificationFileFormContainer